module.exports = "/fonts/fa-brands-400.svg?4009e71782c2fd408c472992660d3e34";